import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { milliseconds } from 'date-fns';
import { ZodError } from 'zod';

import { logger } from '@/lib/logger';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: milliseconds({ minutes: 5 }),
      retry: 1,
    },
    mutations: {
      retry: skipRetryOnZodFailure,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      logger.error('Mutation error', error);
    },
  }),
  queryCache: new QueryCache({
    onError: (error) => {
      logger.error('Query error', error);
    },
  }),
});

function skipRetryOnZodFailure(failureCount: number, error: unknown) {
  if (error instanceof ZodError) return false;
  return failureCount < 3;
}
